import { Injectable } from '@angular/core';
import { FormArray, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { ErroresForm } from '../../documentos/models/firmante-nif';
import { ErrorEnvio } from '../models/error-envio';
import { FormularioEnvioService } from './formulario-envio.service';

@Injectable({
  providedIn: 'root'
})
export class FormularioValidacionesService {

  mensajeErrorNombre: string = '';
  mensajeErrorMail: string = '';
  mensajeErrorSubject: string = '';
  mensajeErrorBodySMS: string = '';
  mensajeErrorAdjuntos: string = '';
  mensajeErrorAvisosFirma: string = '';
  mensajeErrorProgramado: string = '';
  mensajeErrorDocumentos: string = '';
  mensajeErrorOrdenTelefonoSMS: string = '';
  mensajeErrorOrdenTelefonoOTP: string = '';
  mensajeErrorNombreComienzaLibra: string = '';
  mensajeErrorCaducidad: string = '';
  indicesAvisosInvalidos: number[] = [];

  constructor(public formularioEnvioService: FormularioEnvioService) {}

  get nombre(){
    return this.formularioEnvioService.formularioEnvio.controls['nombre']
  }

  get tiposDocumento(){
    return this.formularioEnvioService.formularioEnvio.controls['tiposDocumento']
  }

  get formularioEnvio(){return this.formularioEnvioService.formularioEnvio as FormGroup}

  get reminders_String(){ return this.formularioEnvioService.formularioEnvio.controls['reminders_String']}

  get recordatorio(){ return this.formularioEnvioService.formularioEnvio.controls['recordatorio']}

  get body(){ return this.formularioEnvioService.formularioEnvio.controls['body']}
  get envioXml(){ return this.formularioEnvioService.formularioEnvio.controls['envioXml']}
  get nombreComienzaLibra(){ return this.formularioEnvioService.formularioEnvio.controls['nombreComienzaLibra']}

  //comprobamos los errores antes de enviar el formulario y creamos el mensaje de error.
  isCampoValido(campo:string){
    switch(campo){
      case 'nombre':
        if(this.nombre.errors){
          if(this.nombre.errors.nombreVacio)
          this.mensajeErrorNombre = 'Requerido.'
          if(this.nombre.errors.nombreExiste)
          this.mensajeErrorNombre = 'El nombre del dosier ya existe.'
          if(this.nombre.errors.pattern)
          this.mensajeErrorNombre = 'Lo siguientes caracteres no están permitidos y se deben eliminar antes de guardar el dosier. Caracteres: ", \', /, \\'
          if(this.nombre.errors.maxlength)
          this.mensajeErrorNombre = 'El nombre es demasiado largo, puede contener 250 caracteres como máximo.'
        }
        break;
      case 'ordenMail':
        this.mensajeErrorMail = 'Requerido cuando el envío es por correo electrónico.'
        break;
      case 'ordenTelefonoSMS':
        this.mensajeErrorOrdenTelefonoSMS = 'Requerido cuando el envío es por SMS.'
        break;
      case 'ordenTelefonoOTP':
        this.mensajeErrorOrdenTelefonoOTP = 'Requerido si se ha activado OTP.'
        break;
      case 'bodySMS':
        this.mensajeErrorBodySMS = 'El mensaje de SMS debe contener 110 carácteres como máximo.'
        break;
      case 'tiposDocumento':
        this.mensajeErrorDocumentos = 'Deben de haber como mínimo 2 documentos fusionados.'
        break;
      case 'nombreComienzaLibra':
        this.mensajeErrorNombreComienzaLibra = 'El campo está habilitado, se debe informar del texto por el que empieza el fichero XML.'
        break;
      case 'caducidad':
        this.mensajeErrorCaducidad = 'El campo debe contener un número entre 1 y 365.'
        break;
    }
    if(this.formularioEnvioService.formularioEnvio.controls[campo]){
      return this.formularioEnvioService.formularioEnvio.controls[campo].errors && this.formularioEnvioService.formularioEnvio.controls[campo].touched;
    }else{
      return true;
    }
  }

  //comprobamos los errores del firmantesArrayForm antes de enviar el fomulario
  isCampoValidoArray(campo: string, index: number){
    if(this.formularioEnvioService.firmantes.controls[index]){
      return this.formularioEnvioService.firmantes.controls[index].get(campo)?.errors && this.formularioEnvioService.firmantes.controls[index].get(campo)?.touched;
    }else{
      return true;
    }
  }

  //añadimos los validadores en cada uno de los atributos del firmantesArrayForm
  addValidatorsFirmantesArrayForm(){
    this.formularioEnvioService.firmantes.controls.forEach((x:any, index) => {

      let objectKeys = Object.keys(x['controls']);

      objectKeys.forEach(key => {
        this.formularioEnvioService.firmantes.controls[index].get(`${key}.codigo`)?.setValidators(Validators.required);

        this.formularioEnvioService.firmantes.controls[index].get(`${key}.codigo`)?.updateValueAndValidity();
      })
    })
  }

  //añadimos/quitamos validadores cuando los los campos de ajustes están o no clicados y hacemos el campo readonly cuando no están clicados.
  getCheckboxClick(checkbox: string){
    let condicional: string = '';
    switch (checkbox){
      case 'recordatorio':
        condicional = 'reminders_String'
        this.formularioEnvioService.disableRecordatorio = true;
        break;
    }

    this.formularioEnvioService.formularioEnvio.get(checkbox)?.valueChanges.subscribe(value => {
      if(value) {
        if(checkbox == 'recordatorio'){
          this.formularioEnvioService.formularioEnvio.get(condicional).setValidators([Validators.required, Validators.pattern('^[0-9,]+$')])
          this.formularioEnvioService.disableRecordatorio = false;
        }
      }
      this.formularioEnvioService.formularioEnvio.controls[condicional].updateValueAndValidity();
    })
  }

  get firmantes(){return this.formularioEnvioService.formularioEnvio.get('firmantes') as FormArray}

  getFormValidationErrors(): ErrorEnvio[]{
    let errorAvisos = this.validacionAvisos();
    let erroresForm: ErrorEnvio[] = [];
    let objetoError = {} as ErrorEnvio;
    if(errorAvisos == true){
      objetoError = {
        key: 'Recordatorios programados',
        tipoError: 'errores'
      }
      erroresForm.push(objetoError)
    }
    for (let field in this.formularioEnvio.controls) {
      const control = this.formularioEnvio.get(field);

      if(control.errors){
        let errorKey = Object.keys(control.errors)

        switch (field){
          case 'nombre':
            field = 'Nombre del dosier';
            break;
          case 'ordenMail':
            field = 'Tipo de dirección de e-mail preferida';
            break;
          case 'ordenTelefonoSMS':
            field = 'Teléfono preferido para envío SMS';
            break;
          case 'ordenTelefonoOTP':
            field = 'Teléfono preferido para envío OTP';
            break;
          case 'tiposDocumento':
            field = 'Documentos fusionados';
            break;
          case 'bodySMS':
            field = 'Mensaje del SMS';
            break
          case 'nombreComienzaLibra':
            field = 'Texto por el que empieza el fichero XML';
            break
        }
        switch (errorKey[0]){
          case 'nombreVacio':
            errorKey[0] = 'requerido. También para guardarlo como borrador.';
            break;
          case 'nombreExiste':
            errorKey[0] = 'duplicado.';
            break;
          case 'required':
            errorKey[0] = 'requerido.';
            break;
          case 'docsFusionables':
            errorKey[0] = 'deben de haber como mínimo 2 documentos fusionados.'
            break
          case 'maxlength':
            errorKey[0] = 'debe contener como máximo 110 carácteres.'
        }
        objetoError = {
          key: field,
          tipoError: errorKey[0]
        }
        if(objetoError.key !== 'reminders_String') erroresForm.push(objetoError)
      }
      if(field=='firmantes'){
        this.firmantes.controls.forEach((x,index)=>{
          let firmante = x.get('tipoFirmante').value
          if(x.status !== 'VALID'){
            objetoError = {
              key: firmante.desc,
              tipoError: 'detalles requeridos.'
            }
            erroresForm.push(objetoError)
          }
        })
      }
    }
    if(erroresForm[0]?.key == 'Avisos firma'){
      let errorAvisoCambio = erroresForm.shift();
      erroresForm.push(errorAvisoCambio)
    }
    return erroresForm;
  }


  validacionAvisos(){
    return this.calcularErroresAvisos();
  }

  isAvisoInvalido(index: number): boolean {
    if (this.recordatorio.value !== true) {
      return false;
    }
    this.calcularErroresAvisos();
    return this.indicesAvisosInvalidos.includes(index);
  }

  private calcularErroresAvisos(): boolean {
    this.indicesAvisosInvalidos = [];
    let returnValidacion: boolean[] = [];
    if(this.reminders_String.value !== null && this.recordatorio.value == true){
      const arrayValues = this.reminders_String.value.split(',')
      arrayValues.forEach((x:any, i:number)=> {
        if(x ==''|| x == null){
          this.mensajeErrorAvisosFirma = 'Los avísos son requeridos si se ha marcado la opción "Avisos de firma"'
          returnValidacion.push(true)
          this.indicesAvisosInvalidos.push(i);
        }
        else if(Number(x) < 1 || Number(x) > 60){
          this.mensajeErrorAvisosFirma = 'Los avisos tiene que ser de 1 día como mínimo y 60 como máximo.'
          returnValidacion.push(true)
          this.indicesAvisosInvalidos.push(i);
        }
        else if(i > 0 && parseInt(arrayValues[i], 10) <= parseInt(arrayValues[i-1], 10)){
          this.mensajeErrorAvisosFirma = 'El aviso tiene que ser mayor que el anterior.'
          returnValidacion.push(true)
          this.indicesAvisosInvalidos.push(i);
        }
      })
    }else{
      if(this.recordatorio.value == true) {
        this.mensajeErrorAvisosFirma = 'Los avísos son requeridos si se ha marcado la opción "Avisos de firma"'
        returnValidacion.push(true)
        const totalAvisos = this.formularioEnvioService.recordatorios?.length ?? 0;
        for (let i = 0; i < Math.max(totalAvisos, 1); i++) {
          this.indicesAvisosInvalidos.push(i);
        }
      }
    }
    if(returnValidacion.includes(true)) return true;
    else return false;
  }

  avisoXml:boolean = false;

  checkSiEnvioXml(){
    if(!this.envioXml.value &&
      this.nombreComienzaLibra.value!==undefined &&
      this.nombreComienzaLibra.value!==null &&
      this.nombreComienzaLibra.value!==''
    ) this.avisoXml = true;
    else this.avisoXml= false;
  }
}
